document.addEventListener("DOMContentLoaded", function () {

  // Accordion toggle
  document.querySelectorAll(".accordion-header").forEach(header => {
    header.addEventListener("click", () => {
      const accordion = header.closest(".product-accordion");
      accordion.classList.toggle("active");
    });
  });

  // Read More toggle
  document.querySelectorAll(".read-more-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      const text = btn.previousElementSibling;
      text.classList.toggle("expanded");
      btn.textContent = text.classList.contains("expanded")
        ? "Read less"
        : "Read more";
    });
  });

});